import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
  };
};

export const getCompanies = async (filter = {}) => {
  const response = await axios.post(`${BASE_URL}/api/Company/get`, filter, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const saveCompany = async (company) => {
  const headers = getAuthHeader();

  // If company is FormData (for file upload), don't set Content-Type
  if (company instanceof FormData) {
    const response = await axios.post(`${BASE_URL}/api/Company/save`, company, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } else {
    // For regular JSON data
    const response = await axios.post(`${BASE_URL}/api/Company/save`, company, {
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }
};
